/* ==========================================================================
   CALMAX — carrito (AJAX Cart API nativo de Shopify)
   /cart/add.js · /cart/change.js · /cart/clear.js · /cart.js
   Reemplaza por completo el flujo Storefront API / GraphQL que traía el
   export de Lovable (eso servía para un frontend headless, acá no aplica).
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.Calmax || {};
  var ROUTES = CFG.routes || {
    cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js',
    cartClear: '/cart/clear.js',
    cart: '/cart.js',
    checkout: '/checkout'
  };

  /* El vaciado de sesión se dispara en <head>. Todo lo que toque el carrito
     espera a que termine para que un "agregar" no se pise con el clear. */
  var sessionReady = window.CalmaxSessionReset || Promise.resolve(false);

  var state = { cart: null, busy: false };

  /* ---------------------------------------------------------------- utils */

  function formatMoney(cents) {
    var value = (cents || 0) / 100;
    var opts = { minimumFractionDigits: 0, maximumFractionDigits: 0 };
    if (Math.round(value) !== value) {
      opts.minimumFractionDigits = 2;
      opts.maximumFractionDigits = 2;
    }
    return '$' + value.toLocaleString('es-AR', opts);
  }

  /* Un ID todavía sin cargar en snippets/variant-ids.liquid se ve como
     "REEMPLAZAR-almohada-rodilla-1u". Se avisa en vez de romper el carrito. */
  function isPlaceholderId(id) {
    return !id || !/^\d+$/.test(String(id).trim());
  }

  function toast(message, type) {
    var host = document.querySelector('[data-toast-host]');
    if (!host) { return; }
    var el = document.createElement('div');
    el.className = 'toast' + (type ? ' toast--' + type : '');
    el.textContent = message;
    host.appendChild(el);
    setTimeout(function () { el.remove(); }, 3200);
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) { throw new Error(data.description || data.message || 'Error del carrito'); }
        return data;
      });
    });
  }

  /* ------------------------------------------------------------- cart API */

  function getCart() {
    return sessionReady.then(function () {
      return fetch(ROUTES.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      state.cart = cart;
      render();
      return cart;
    });
  }

  function addToCart(items) {
    return sessionReady
      .then(function () { return postJSON(ROUTES.cartAdd, { items: items }); })
      .then(function () { return getCart(); });
  }

  function changeLine(lineIndex, quantity) {
    return sessionReady
      .then(function () { return postJSON(ROUTES.cartChange, { line: lineIndex, quantity: quantity }); })
      .then(function (cart) { state.cart = cart; render(); return cart; });
  }

  /* --------------------------------------------------------------- drawer */

  var drawer, overlay;

  function openDrawer() {
    if (!drawer) { return; }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function upsellData() {
    var el = document.getElementById('calmax-upsells');
    if (!el) { return []; }
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  function renderCount() {
    var count = state.cart ? state.cart.item_count : 0;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function lineHTML(item, index) {
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') + '" alt="' + escapeAttr(item.product_title) + '" loading="lazy">'
      : '';
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-line__variant">' + escapeHTML(item.variant_title) + '</p>'
      : '';

    var propsLine = '';
    if (item.properties) {
      var entries = Object.keys(item.properties).filter(function (k) {
        return k.charAt(0) !== '_' && item.properties[k];
      });
      if (entries.length) {
        propsLine = '<ul class="cart-line__props">' + entries.map(function (k) {
          return '<li><span>' + escapeHTML(k) + ':</span> ' + escapeHTML(item.properties[k]) + '</li>';
        }).join('') + '</ul>';
      }
    }

    return '' +
      '<div class="cart-line" data-line="' + (index + 1) + '">' +
        '<div class="cart-line__img">' + img + '</div>' +
        '<div class="cart-line__info">' +
          '<h4 class="cart-line__title">' + escapeHTML(item.product_title) + '</h4>' +
          variantLine +
          propsLine +
          '<p class="cart-line__price">' + formatMoney(item.final_line_price) + '</p>' +
          '<span class="cart-line__cuotas">' + iconSVG('credit-card') + 'Cuotas sin interés</span>' +
        '</div>' +
        '<div class="cart-line__actions">' +
          '<button type="button" class="cart-line__remove" data-line-remove="' + (index + 1) + '" aria-label="Eliminar">' + iconSVG('trash') + '</button>' +
          '<div class="cart-line__qty">' +
            '<button type="button" data-line-qty="' + (index + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Restar">' + iconSVG('minus') + '</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line-qty="' + (index + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Sumar">' + iconSVG('plus') + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function upsellHTML(cart) {
    var data = upsellData();
    if (!data.length) { return ''; }

    /* Regla del cliente: la lista va siempre en el mismo orden y solo se saca
       lo que ya está en el carrito. El filtro va por handle (no por variante)
       para que agregar el pack de 2 también esconda la tarjeta del pack de 1. */
    var inCart = {};
    (cart.items || []).forEach(function (i) {
      inCart[String(i.variant_id)] = true;
      if (i.handle) { inCart[String(i.handle)] = true; }
    });

    var cards = data.filter(function (u) {
      return !inCart[String(u.variantId)] && !(u.handle && inCart[String(u.handle)]);
    }).map(function (u) {
      var media = u.image
        ? '<img src="' + u.image + '" alt="' + escapeAttr(u.title) + '" loading="lazy">'
        : '<span class="upsell-card__emoji">' + (u.emoji || '🎁') + '</span>';
      var prices = '' +
        (u.oldPrice ? '<span class="upsell-card__old">' + escapeHTML(u.oldPrice) + '</span>' : '') +
        (u.newPrice ? '<span class="upsell-card__new">' + escapeHTML(u.newPrice) + '</span>' : '');

      return '' +
        '<div class="upsell-card">' +
          '<div class="upsell-card__top">' + media +
            '<div>' +
              '<p class="upsell-card__title">' + escapeHTML(u.title) + '</p>' +
              '<div class="upsell-card__prices">' + prices + '</div>' +
            '</div>' +
          '</div>' +
          '<p class="upsell-card__desc">' + escapeHTML(u.description || '') + '</p>' +
          '<button type="button" class="upsell-card__btn" data-upsell-add="' + escapeAttr(u.variantId) + '">+ Agregar al pedido</button>' +
        '</div>';
    });

    if (!cards.length) { return ''; }

    return '' +
      '<div class="cart-upsells">' +
        '<div class="cart-upsells__head">' +
          '<p>Aprovechá los descuentos</p>' +
          '<span class="cart-upsells__badge">🔥 Hasta 55% OFF solo por tu pedido</span>' +
        '</div>' +
        '<div class="cart-upsells__track">' + cards.join('') + '</div>' +
      '</div>';
  }

  function render() {
    renderCount();
    if (!drawer || !state.cart) { return; }

    var cart = state.cart;
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var sub = drawer.querySelector('[data-cart-subtitle]');
    var shipping = drawer.querySelector('[data-cart-shipping]');

    if (sub) {
      sub.textContent = cart.item_count === 0
        ? 'Tu carrito está vacío'
        : cart.item_count + ' producto' + (cart.item_count !== 1 ? 's' : '') + ' en tu carrito';
    }

    /* Barra de envío gratis */
    if (shipping) {
      var threshold = (CFG.freeShippingThreshold || 0) * 100;
      if (cart.item_count === 0 || !threshold) {
        shipping.hidden = true;
      } else {
        shipping.hidden = false;
        var remaining = threshold - cart.total_price;
        if (remaining > 0) {
          shipping.classList.remove('is-free');
          shipping.innerHTML = iconSVG('truck') + '<span>Te faltan ' + formatMoney(remaining) + ' para envío gratis</span>';
        } else {
          shipping.classList.add('is-free');
          shipping.innerHTML = iconSVG('truck') + '<span>🎉 ¡Felicitaciones! Tenés envío gratis</span>';
        }
      }
    }

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty">' + iconSVG('shopping-cart') + '<p>Tu carrito está vacío</p></div>';
      foot.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(lineHTML).join('') + upsellHTML(cart);
    foot.hidden = false;

    var savings = cart.items.reduce(function (sum, item) {
      var compare = item.original_price || 0;
      var current = item.final_price || 0;
      return sum + (compare > current ? (compare - current) * item.quantity : 0);
    }, 0);

    foot.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price);
    foot.querySelector('[data-cart-cuotas]').textContent =
      '(Podés pagar en 3 cuotas sin interés de ' + formatMoney(Math.round(cart.total_price / 3)) + ')';

    var savingsEl = foot.querySelector('[data-cart-savings]');
    if (savings > 0) {
      savingsEl.hidden = false;
      savingsEl.textContent = 'Ahorrás ' + formatMoney(savings);
    } else {
      savingsEl.hidden = true;
    }
  }

  /* ------------------------------------------------------------- helpers */

  function escapeHTML(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function escapeAttr(str) {
    return escapeHTML(str).replace(/"/g, '&quot;');
  }

  var ICONS = {
    'credit-card': '<rect width="20" height="14" x="2" y="5" rx="2"/><path d="M2 10h20"/>',
    trash: '<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>',
    plus: '<path d="M5 12h14"/><path d="M12 5v14"/>',
    minus: '<path d="M5 12h14"/>',
    truck: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    'shopping-cart': '<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>'
  };

  function iconSVG(name) {
    return '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }

  function setLoading(btn, loading) {
    if (!btn) { return; }
    btn.disabled = loading;
    btn.classList.toggle('is-loading', loading);
    if (loading) {
      if (!btn.querySelector('.spinner')) {
        var s = document.createElement('span');
        s.className = 'spinner';
        btn.appendChild(s);
      }
    } else {
      var sp = btn.querySelector('.spinner');
      if (sp) { sp.remove(); }
    }
  }

  /* --------------------------------------------------------------- events */

  function handleAdd(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var quantity = parseInt(btn.getAttribute('data-quantity') || '1', 10);
    var successMessage = btn.getAttribute('data-success-message');

    if (isPlaceholderId(variantId)) {
      toast('Falta cargar el variant ID de esta opción (snippets/variant-ids.liquid).', 'error');
      console.warn('[Calmax] Variant ID sin cargar:', variantId);
      return;
    }
    if (state.busy) { return; }
    state.busy = true;
    setLoading(btn, true);

    /* Opciones por unidad (color de cada almohada, talle de cada par…).
       calmax-ui.js las deja acá; viajan como propiedades de línea. */
    var line = { id: Number(variantId), quantity: quantity };
    var rawProps = btn.getAttribute('data-properties');
    if (rawProps) {
      try {
        var props = JSON.parse(rawProps);
        if (props && Object.keys(props).length) { line.properties = props; }
      } catch (e) {
        console.warn('[Calmax] data-properties inválido:', rawProps);
      }
    }

    addToCart([line])
      .then(function () {
        toast(successMessage || 'Producto agregado al carrito', 'success');
        openDrawer();
      })
      .catch(function (err) {
        toast(err.message || 'No pudimos agregar el producto. Reintentá en unos segundos.', 'error');
      })
      .finally(function () {
        state.busy = false;
        setLoading(btn, false);
      });
  }

  function init() {
    drawer = document.querySelector('[data-cart-drawer]');
    overlay = drawer ? drawer.querySelector('[data-cart-overlay]') : null;

    document.addEventListener('click', function (event) {
      var el;

      if ((el = event.target.closest('[data-cart-add]'))) {
        event.preventDefault();
        handleAdd(el);
        return;
      }
      if ((el = event.target.closest('[data-cart-open]'))) {
        event.preventDefault();
        openDrawer();
        getCart();
        return;
      }
      if (event.target.closest('[data-cart-close]') || (overlay && event.target === overlay)) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if ((el = event.target.closest('[data-line-qty]'))) {
        var qty = parseInt(el.getAttribute('data-qty'), 10);
        changeLine(parseInt(el.getAttribute('data-line-qty'), 10), Math.max(0, qty))
          .catch(function (err) { toast(err.message, 'error'); });
        return;
      }
      if ((el = event.target.closest('[data-line-remove]'))) {
        changeLine(parseInt(el.getAttribute('data-line-remove'), 10), 0)
          .catch(function (err) { toast(err.message, 'error'); });
        return;
      }
      if ((el = event.target.closest('[data-upsell-add]'))) {
        var upsellId = el.getAttribute('data-upsell-add');
        if (isPlaceholderId(upsellId)) {
          toast('Falta cargar el variant ID de este upsell (snippets/variant-ids.liquid).', 'error');
          return;
        }
        el.disabled = true;
        el.textContent = '✓ ¡Agregado!';
        addToCart([{ id: Number(upsellId), quantity: 1 }])
          .catch(function (err) { toast(err.message, 'error'); });
        return;
      }
      if (event.target.closest('[data-cart-checkout]')) {
        event.preventDefault();
        window.location.href = ROUTES.checkout;
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closeDrawer(); }
    });

    getCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CalmaxCart = {
    get: getCart,
    add: addToCart,
    change: changeLine,
    open: openDrawer,
    close: closeDrawer,
    formatMoney: formatMoney
  };
})();
